import React from 'react';
import {GlobalStyles as MuiGLobalStyles, useTheme} from '@mui/material';

export function GlobalStyles() {
	const theme = useTheme();

	const styles = {
		'*': {
			margin: 0,
			padding: 0,
			boxSizing: 'border-box',
		},
		html: {
			fontSize: '16px',
		},
		body: {
			backgroundColor: theme.palette.grey[200],
			color: theme.palette.primary.main,
		},
		button: {
			backgroundColor: 'transparent',
			cursor: 'pointer',
			outline: 'none',
			border: 'none',
		},
		ul: {
			listStyle: 'none',
		},
		a: {
			textDecoration: 'none',
		},
		'body, button, input, textarea': {
			fontFamily: theme.typography.fontFamily,
			fontWeight: 400,
			fontSize: '1rem',
		},
		'h1, h2, h3, h4, h5, h6, strong': {
			fontWeight: 600,
		},
	};

	return <MuiGLobalStyles styles={styles} />;
}
